var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { "data-test": "tab-share--embed" } }, [
    _c("h3", { staticClass: "mb-2", style: _vm.font }, [
      _vm._v(_vm._s(_vm.$t("SHARE.EMBED.TITLE")))
    ]),
    _c(
      "div",
      { staticClass: "flex w-full" },
      [
        _c("input", {
          staticClass: "block text-sm p-1 rounded-sm mr-2 w-full border",
          style: {
            color: _vm.contrast,
            background: _vm.background,
            "border-color": _vm.brandColor
          },
          attrs: {
            "aria-label": _vm.$t(_vm.inputLabel.key, _vm.inputLabel.attr),
            disabled: true,
            "data-test": "tab-share--embed--input"
          },
          domProps: { value: _vm.embedCode }
        }),
        _c(
          "tooltip",
          {
            attrs: {
              content: _vm.$t("MESSAGES.COPIED"),
              trigger: "click",
              color: _vm.brandColor,
              background: _vm.brandLightest,
              placement: "top"
            },
            on: { click: _vm.copyCode }
          },
          [
            _c(
              "button",
              {
                staticClass:
                  "block px-8 py-2 text-sm p-1 rounded-sm mr-2 w-full border",
                style: Object.assign(
                  {},
                  { color: _vm.brandColor, background: _vm.background },
                  _vm.font,
                  { "border-color": _vm.brandColor }
                ),
                attrs: { title: _vm.$t(_vm.copyLabel.key, _vm.copyLabel.attr) }
              },
              [
                _c("span", { attrs: { "aria-hidden": "true" } }, [
                  _vm._v(_vm._s(_vm.$t("SHARE.ACTIONS.COPY")))
                ])
              ]
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }